import classes from "../../classes";
import { Redirect } from "react-router-dom";
import React from "react";

export default class AmountForm extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedButton: "bonus-100",
      customAmount: "200.00"
    };
    this.focusAmount = this.focusAmount.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setCustomDepositAmount = this.setCustomDepositAmount.bind(this);
    this.setDepositAmountFromInput = this.setDepositAmountFromInput.bind(this);

    const defaultAmount = 100;
    var { deposit, setDepositAmount } = props;
    var amount = deposit.get("amount");
    if (amount !== defaultAmount || deposit.get("confirmed")) {
      setDepositAmount(defaultAmount);
    }
  }

  focusAmount() {
    this.refs.amount.focus();
  }

  isValid() {
    var { deposit } = this.props;
    var amount = deposit.get("amount");
    return amount >= 5;
  }

  onSubmit(e) {
    e.preventDefault();
    var { history } = this.props;
    if (this.isValid()) {
      history.push("/deposit/address");
    } else {
      this.refs.amount.setCustomValidity("Please choose a value greater than $5.00");
    }
  }

  setCustomDepositAmount() {
    this.setState({ selectedButton: "bonus-200", customAmount: this.refs.amount.value }); // eslint-disable-line react/no-set-state
    this.setDepositAmountIfNumber(this.refs.amount.value);
  }

  setDepositAmountFromInput(e) {
    this.setState({ selectedButton: e.target.id }); // eslint-disable-line react/no-set-state
    this.setDepositAmountIfNumber(e.target.value);
  }

  setDepositAmountIfNumber(amount) {
    var { setDepositAmount } = this.props;
    if (amount.length === 0) {
      setDepositAmount(undefined);
      return;
    }
    var n = parseFloat(amount);
    if (!isNaN(n)) {
      setDepositAmount(n);
    }
  }

  render() {
    var { customAmount, selectedButton } = this.state;

    if (!window.env.showAccountPages) {
      return (<Redirect to="/tournaments" />);
    }

    var { largeButton, buttonLabel } = this.props;
    if (!buttonLabel) {
      buttonLabel = "Continue";
    }

    return (
      <form autoComplete="off" onSubmit={this.onSubmit}>
        <div className="selector_container">

          <div className="selector selector--is-basic">
            <input
              checked={selectedButton === "bonus-25"}
              className="selector_input"
              id="bonus-25"
              name="bonus"
              onChange={this.setDepositAmountFromInput}
              type="radio"
              value="25" />

            <label className="selector_label" htmlFor="bonus-25">
              <span className="selector_amount">
                $25
              </span>

              <span className="selector_icon">
                <i className="dw-checkmark3" />
              </span>

              <span className="btn">
                Select
              </span>
            </label>
          </div>

          <div className="selector selector--is-basic">
            <input
              checked={selectedButton === "bonus-50"}
              className="selector_input"
              id="bonus-50"
              name="bonus"
              onChange={this.setDepositAmountFromInput}
              type="radio"
              value="50" />

            <label className="selector_label" htmlFor="bonus-50">
              <span className="selector_amount">
                $50
              </span>

              <span className="selector_icon">
                <i className="dw-checkmark3" />
              </span>

              <span className="btn">
                Select
              </span>
            </label>
          </div>

          <div className="selector selector--is-basic">
            <input
              checked={selectedButton === "bonus-100"}
              className="selector_input"
              id="bonus-100"
              name="bonus"
              onChange={this.setDepositAmountFromInput}
              type="radio"
              value="100" />

            <label className="selector_label" htmlFor="bonus-100">
              <span className="selector_amount">
                $100
              </span>

              <span className="selector_icon">
                <i className="dw-checkmark3" />
              </span>

              <span className="btn">
                Select
              </span>
            </label>
          </div>

          <div className="selector selector--is-basic">
            <input
              checked={selectedButton === "bonus-200"}
              className="selector_input"
              id="bonus-200"
              name="bonus"
              onChange={this.setCustomDepositAmount}
              type="radio"
              value={customAmount} />

            <label className="selector_label" htmlFor="bonus-200" onClick={this.focusAmount}>
              <span className="selector_note">
                Custom (Min $5.00)
              </span>

              <div className="form_input-prefix" data-prefix="$">
                <input
                  className="form_input"
                  min="5.00"
                  name="amount"
                  onChange={this.setCustomDepositAmount}
                  onClick={this.setCustomDepositAmount}
                  placeholder="5.00"
                  ref="amount"
                  step="0.01"
                  type="number"
                  value={customAmount} />
              </div>

              <span className="selector_icon">
                <i className="dw-checkmark3" />
              </span>

              <span className="btn">
                Select
              </span>
            </label>
          </div>
        </div>

        <div className="text-center margin-bottom--is-40">
          <input
            className={classes({
              "btn": true,
              "btn--emphasis": true,
              "btn--is-disabled": !this.isValid(),
              "btn--large": largeButton,
              "btn--primary": true
            })} type="submit" value={buttonLabel} />
        </div>
      </form>
    );
  }
}

